export default __webpack_public_path__ + "static/media/config.61858692.png";